// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1YXen","head":"ProcedureTableInfo_head__3Sgm2"};